import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { API_BASE_URL } from '../../../core/config/api-base-url.token';
import { BackendUserAuthResponse } from '../models/backend-user.model';

@Injectable({
  providedIn: 'root',
})
export class AuthUserService {
  private readonly httpClient = inject(HttpClient);
  private readonly apiBaseUrl = inject(API_BASE_URL);

  public getUserByUid(uid: string): Observable<BackendUserAuthResponse> {
    return this.httpClient.post<BackendUserAuthResponse>(`${this.apiBaseUrl}/user`, { uid });
  }

  public signOut(): Observable<void> {
    return this.httpClient.get<void>(`${this.apiBaseUrl}/user/signout`);
  }
}
